export enum CommonAnswersPets {
  YES = "yes",
  NO = "no",
  DEPENDS = "depends",
}

export enum EnergyLevel {
  HIGH = "high",
  MODERATE = "moderate",
  LOW = "low",
}

export enum Gender {
  MALE = "male",
  FEMALE = "female",
  OTHER = "other",
  UNKNOWN = "unknown",
}

export enum IndoorOutdoor {
  INDOOR = "indoor",
  OUTDOOR = "outdoor",
  BOTH = "both",
}

export enum CanBeHandled {
  YES = "yes",
  NO = "no",
  WITH_CARE = "withCare",
}

export enum AgeType {
  PUPPY = "puppy",
  ADULT = "adult",
  CUSTOM = "custom",
}
